let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3w87s")).then(() => parcelRequire('4PP3r'));